import s from './style.module.scss';
import { useCallback, useState } from 'react';
import useStatusBarHeight from '@/hooks/useStatusBarHeight';
import Step1 from './step1';
import Step2 from './step2';
import Step3 from './step3';
import Step4 from './step4';
import cx from 'classnames';
import { postWithAuth } from '@/util/request';

import { useTranslation } from 'react-i18next';
import { useToast } from '@/stores/ToastContext';

// const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJEdWV0X09mZmljaWFsIiwic3ViIjoiQWNjb3VudE1hbmFnZW1lbnQiLCJhdWQiOlsiRHVldF9XZWIiXSwiZXhwIjoxNzEzMTg2NjQwLCJpYXQiOjE3MTMxODMwNDAsImF0IjoiMmIwYzY5MzBiZWU5ZDM2ODZiMDRmZDdmMWYzYWZjMzc1NTE5NDY1ZDAxOGNkNDUxYWQ3NjNkZGI4YmZmNTRkZCJ9._gdgYeOuBapuXiHgG92KxNgLpEEfV0FbmrPXURc7o8Q';

export default function Questionnaire() {
  const showToast = useToast();
  const [answerDic, setAnswerDic] = useState({});
  const { t } = useTranslation();
  const statusBarHeight = useStatusBarHeight();
  const [step, setStep] = useState(1);
  const [showConfirm, setShowConfirm] = useState(false);
  const [q3Answer, setQ3Answer] = useState({});

  const handleConfirm = useCallback(async () => {
    if (!showConfirm) {
      if (step === 4) {
        showToast(t('DUET_QUESTIONNAIRE_Q4_ERROR_TOAST'));
      }
      return;
    }
    if (step === 3) {
      setAnswerDic(Object.assign(answerDic, { q3: Object.values(q3Answer).join(',') }));
    }
    if (step < 4) {
      return setStep(step + 1);
    } else {
      const res = await postWithAuth(
        `${window.location.protocol}//${window.location.host}/web/account/inactivate-questionnaire`,
        {
          ...answerDic,
        }
      );
      if (res.meta?.code === 200) {
        window?.nativeBridge && window.nativeBridge.callNativeFunction('onCompleteQuestionnaire', null);
      } else {
        showToast(t('DUET_H5_ACCOUNT_MANAGE_ERROR_PAGE_TITLE'));
      }
    }
  }, [step, answerDic, q3Answer, showConfirm]);

  return (
    <div className={s.root} style={{ paddingTop: `${statusBarHeight + 0.12}rem` }}>
      <div className={cx(s.confirm, { [s.hide]: step === 1 }, { [s.active]: showConfirm })} onClick={handleConfirm}>
        {t('DUET_QUESTIONNAIRE_ASKING_YES')}
      </div>
      <div className={s.processBar}>
        <div className={s.process} style={{ width: `${0.9375 * step}rem` }} />
      </div>
      {step === 1 && <Step1 setStep={setStep} setAnswerDic={setAnswerDic} answerDic={answerDic} />}
      {step === 2 && (
        <Step2 setStep={setStep} setAnswerDic={setAnswerDic} setShowConfirm={setShowConfirm} answerDic={answerDic} />
      )}
      {step === 3 && (
        <Step3
          setStep={setStep}
          setAnswerDic={setAnswerDic}
          setShowConfirm={setShowConfirm}
          answerDic={answerDic}
          setQ3Answer={setQ3Answer}
          q3Answer={q3Answer}
        />
      )}
      {step === 4 && (
        <Step4 setStep={setStep} setAnswerDic={setAnswerDic} setShowConfirm={setShowConfirm} answerDic={answerDic} />
      )}
    </div>
  );
}
